import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=50f2eba5&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2eba5",
  null
  
)

export default component.exports